import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setLoginSuccessWithStorageThunk } from '@liefersoft/pos-ui-core'
import { localStorageApi } from '../../helper/localStorageApi'
import { setCompanyRegistered, setLocalStorageLoaded, setLoginData } from '../../redux/action'
import { getAccessToken, getRefreshToken } from './helper'
import { setCartDiscountType } from '../../redux/action/cartDiscount'
import { PERCENTS } from '../../redux/reducer/businessScopeDiscount/constants'
import { logger } from '../../logger/logger'
import { cleanupDomainCookies } from '../../helper/cookieToken'

const LoadLocalStorage = () => {
	const dispatch = useDispatch()

	useEffect(() => {
		const loadLocalStorage = () => {
			cleanupDomainCookies()

			try {
				const login = localStorageApi.getItem('login')
				const companyIndex = localStorageApi.getItem('companyIndex')
				const accessToken = getAccessToken()
				const refreshToken = getRefreshToken()
				const discount = localStorageApi.getItem('discount') ?? PERCENTS
				const complete = localStorageApi.getItem('complete') ?? false

				dispatch(setLoginData({ email: login, companyIndex: companyIndex?.toUpperCase() }))
				if (accessToken) {
					dispatch(setLoginSuccessWithStorageThunk({ accessToken, refreshToken }))
				}
				dispatch(setCartDiscountType(discount))
				dispatch(setCompanyRegistered(complete))
				dispatch(setLocalStorageLoaded(true))
			} catch (e) {
				logger.warn('LoadLocalStorage error', e)
			}
		}
		loadLocalStorage()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return null
}

LoadLocalStorage.displayName = 'LoadLocalStorage'
export default LoadLocalStorage
